export default {
  name: 'employeeRecordRequest',
  miniSave: true,
  uploadFunction: ({ requestFunction, data, saveId }) => {
    return requestFunction.methodRequest(`/employee/${data.employeeid}/forms/recordrequest`, 'PUT', data);
  },
  restoreSave: (ctx) => {
  }
}
